var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-7 -6 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M45.38,42.79V38.778c0-1.972-.425-3.478-2.725-3.478a2.378,2.378,0,0,0-2.15,1.178h-.027v-1H38.3V42.79h2.273V39.162c0-.959.178-1.876,1.356-1.876s1.178,1.082,1.178,1.931v3.56H45.38Z",
    transform: "translate(-34.425 -31.836)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M11.3,36.6h2.273v7.312H11.3Z",
    transform: "translate(-11.122 -32.957)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M11.315,10a1.321,1.321,0,1,0,1.315,1.315A1.315,1.315,0,0,0,11.315,10Z",
    transform: "translate(-10 -10)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.adc1eabd8631d6f46648dba765230201.svg";
export { ForwardRef as ReactComponent };